/**
 *
 * HighNoShowRiskBadge
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';

import InsuranceSecondaryIcon from 'assets/v2/InsuranceSecondaryIcon';
import { COLORS } from 'theme';
import Badge from '..';

const StyledBadge = styled(Badge)`
  &.MuiChip-root {
    color: ${COLORS.coralDark};
    background: ${COLORS.coralLight};
    border-color: ${COLORS.coral};
  }

  &.MuiButtonBase-root.MuiChip-root:hover {
    background-color: ${COLORS.coralLight};
    opacity: 0.88;
  }

  && .MuiSvgIcon-root {
    path {
      fill: ${COLORS.red};
    }
  }
`;

const CenteredSpinner = styled(CircularProgress)`
  position: absolute;
  transform: translate(-50%, -50%);
`;

function HighNoShowRiskBadge({ loading, ...props }) {
  return (
    <StyledBadge
      icon={
        <>
          <InsuranceSecondaryIcon />
          {loading && <CenteredSpinner size={19} color="inherit" />}
        </>
      }
      label="High No-Show Risk"
      {...props}
    />
  );
}

HighNoShowRiskBadge.propTypes = {
  loading: PropTypes.bool,
};

export default memo(HighNoShowRiskBadge);
